/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import changeforgottenpasswordConfig from './changeforgottenpassword.config.js';
import changeforgottenpasswordRoute from './changeforgottenpassword.route.js';
import changeforgottenpasswordController from './changeforgottenpassword.controller.js';

/**
 * This is the changeforgottenpassword module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace changeforgottenpassword Module
 */
angular.module('changeforgottenpassword', [
  // Shared modules.
  core
])
// Register config.
.config(changeforgottenpasswordConfig)
// Register route.
.config(changeforgottenpasswordRoute)
// Register controller.
.controller('changeforgottenpasswordController', changeforgottenpasswordController)

export default 'changeforgottenpassword';


// WEBPACK FOOTER //
// ./src/login/changeforgottenpassword/changeforgottenpassword.module.js